// src/lib/languages.ts

export interface Language {
  polylangCode: string;
  polylangLocale: string;
  displayCode: string;
  displayName: string;
  preferredBy: string[];
}

// Master list of every language the app knows about.
// Which of these are active on a given deployment is controlled by env.
const ALL_LANGUAGES: Language[] = [
  {
    polylangCode: "pt",
    polylangLocale: "pt-PT",
    displayCode: "PT",
    displayName: "Porto",
    preferredBy: [
      "pt","pt-PT","pt-BR","pt-AO","pt-MZ","pt-GW","pt-CV","pt-ST","pt-TL","pt-MO",
    ],
  },
  {
    polylangCode: "es",
    polylangLocale: "es-ES",
    displayCode: "ES",
    displayName: "Barcelona",
    preferredBy: [
      "es","es-ES","es-MX","es-AR","es-CO","es-PE","es-VE","es-CL","es-EC","es-GT","es-CU","es-BO",
      "es-DO","es-HN","es-PY","es-SV","es-NI","es-CR","es-PA","es-UY","es-PR","es-GQ","es-AD","es-BZ",
    ],
  },
];

const defaultCode = (process.env.NEXT_PUBLIC_DEFAULT_LANG ?? "").trim();

// Optional: NEXT_PUBLIC_ENABLED_LANGS="pt,es" to activate multiple.
// When unset, only the default language is active.
const enabledCodesEnv = (process.env.NEXT_PUBLIC_ENABLED_LANGS ?? "").trim();
const enabledCodes = enabledCodesEnv
  ? enabledCodesEnv.split(",").map((s) => s.trim()).filter(Boolean)
  : defaultCode
    ? [defaultCode]
    : [];

export const LANGUAGES: Language[] =
  enabledCodes.length > 0
    ? ALL_LANGUAGES.filter((l) => enabledCodes.includes(l.polylangCode))
    : ALL_LANGUAGES;

export const DEFAULT_LANGUAGE =
  (defaultCode && LANGUAGES.find((l) => l.polylangCode === defaultCode)) ||
  LANGUAGES[0];

export const ACCEPTED_LOCALES = LANGUAGES.map((l) => l.polylangCode);